import { passwordRegex } from '@/helpers/common';

export default {
  validate (value) {
    let valid = true;

    if (
      !value ||
      value.length < this.constants.PASSWORD_MIN ||
      value.length > this.constants.PASSWORD_MAX ||
      !passwordRegex.test(value)
    ) valid = false;

    return {
      valid,
      required: true,
    };
  },
  message (fieldName, { _value_: v }) {
    if (!v) return 'Please enter your password.';
    return `Password length must be between ${this.constants.PASSWORD_MIN} and ${this.constants.PASSWORD_MAX} characters and must not contain spaces at the beginning or end.`;
  },
  computesRequired: true,
};
